module.exports = __webpack_public_path__ + "static/50-0184f02645235b37c12a8908d436cf60.png";